import type { ObjectData } from '@os/doc';

/** Points are relative to the arrow's (x, y). */
export function ArrowObject({ o }: { o: Extract<ObjectData, { type: 'arrow' }> }) {
  const marker = `arrowhead-${o.id}`;
  const stroke = typeof o.style.stroke === 'string' ? o.style.stroke : 'var(--canvas-ink, #141414)';
  return (
    <svg width={Math.max(o.w, 1)} height={Math.max(o.h, 1)} className="block overflow-visible" aria-hidden="true">
      <defs>
        <marker id={marker} viewBox="0 0 10 10" refX="9" refY="5" markerWidth="8" markerHeight="8" orient="auto-start-reverse">
          <path d="M0,0 L10,5 L0,10 Z" style={{ fill: stroke }} />
        </marker>
      </defs>
      <polyline points={o.points.map((p) => `${p.x},${p.y}`).join(' ')} markerEnd={`url(#${marker})`} style={{ fill: 'none', stroke, strokeWidth: 2 }} />
    </svg>
  );
}
